@if (canViewOtherUsers()) {
  <div class="person-selector">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <input
        type="text"
        matInput
        placeholder="Select a user to view"
        aria-label="Select a user to view"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onOptionSelected($event)"
      >
        @for (person of peopleOptions(); track person.id) {
          <mat-option [value]="person" class="person-selector-option">
            <div class="option-name">{{ person.name }}</div>
            @if (person.adUpn) {
              <div class="option-upn">{{ person.adUpn }}</div>
            }
          </mat-option>
        }
      </mat-autocomplete>
      @if (selectedPerson()) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear selection"
          (click)="clearSelection($event)"
        >
          <mat-icon svgIcon="sqep:close" style="color: white" />
        </button>
      }
    </mat-form-field>
    <mat-icon
      svgIcon="sqep:help"
      class="help-icon"
      matTooltip="Search for and select another user you have access to and see the start page as they see it. Clear the selection to return to your own start page data."
      matTooltipPosition="above"
      aria-label="Help: Search for someone to view their dashboard"
    />
  </div>
}
